import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { Observable } from "rxjs";

import { LoginLimitConfigService } from "./login-limit.config";
import { LoginLimitProgressState, LoginLimitRemove, LoginLimitState, LoginLimitUpdate } from "./login-limit.model";

@Injectable({
	providedIn: "root",
})
export class LoginLimitService {
	constructor(
		private httpClient: CoreHttpClient,
		private config: LoginLimitConfigService
	) {}

	get(): Observable<LoginLimitState> {
		return this.httpClient.get<LoginLimitState>({
			url: this.config.getLoginLimitEndpoint(),
		});
	}

	getProgress(): Observable<LoginLimitProgressState> {
		return this.httpClient.get<LoginLimitProgressState>({
			url: this.config.getLoginLimitProgressEndpoint(),
		});
	}

	update(params: LoginLimitUpdate): Observable<void> {
		return this.httpClient.put<void>({
			url: this.config.getLoginLimitEndpoint(),
			data: params,
		});
	}

	remove(params: LoginLimitRemove): Observable<void> {
		return this.httpClient.delete<void>({
			url: this.config.getLoginLimitEndpoint(),
			data: params,
		});
	}
}
